/* MOLORA Stick-Vorschau v1.0 (27.10.2026)
   Zeichnet Name + Symbol in der Teppich-Vorschau so, wie die PES-Datei gestickt wird.

   Daten: assets/molora-stick-monicha.json, erzeugt aus Stickdatei\Schriftfont\monicha-tr
   (Satin-Schienen je Buchstabe -> gefuellte Umrisse inkl. Zugausgleich 0,4 mm und
   Mindest-Satinbreite 2,5 mm) plus horiz_adv_x, kerning_pairs und den kerning_overrides
   aus Stickdatei\_automation\config.example.json.

   Layout = Port von inkstitch_font.build_stitches() und pes_generator.generate():
     - Hoehe 70 mm (Umriss der Schienen), Breite nach Zeichenzahl 115 mm + 6 mm je Zeichen
       ueber 5, nur Stauchen (min 0,45), nie Strecken; Versalien-Luecken im Mittelband
       (caps_gap 3, lower_caps_gap 4, caps_lower_overlap 8), Deckel caps_max_breite 130
     - Symbol 42 mm hoch, 12 mm Abstand, je Block senkrecht mittig (compose_row)
     - Symbol zwischen zwei Namen: beide gleich hoch + gleiche Stauchung (_paar)
     - Gesamtmotiv max. 295 mm
   Aendert sich eine Regel in config.example.json / inkstitch_font.py, hier nachziehen
   (Werte stehen im JSON unter "prm", Daten neu erzeugen mit dem Export aus dem Chat).

   Arabisch (Malika) laeuft weiter ueber die alte Zeichnung in blocks/_product-media-gallery.
*/
(function(){
  'use strict';
  if (window.mlrStick) return;
  var D = window.__mlrStickData || null, loading = null, waiters = [];
  var URL_ = window.__mlrStickUrl;

  function load(){
    if (D || loading || !URL_) return;
    loading = fetch(URL_, { credentials: 'omit' }).then(function(r){ return r.json(); }).then(function(j){
      D = j;
      var w = waiters; waiters = [];
      w.forEach(function(fn){ try { fn(); } catch (e) {} });
    }).catch(function(){ loading = null; });
  }
  load();

  var RTL = /[؀-ۿ]/;
  function isUp(c){ return c.length === 1 && c !== c.toLowerCase() && c === c.toUpperCase(); }
  function isLow(c){ return c.length === 1 && c !== c.toUpperCase() && c === c.toLowerCase(); }

  function substitute(t){
    var out = '';
    for (var i = 0; i < t.length; i++) {
      var ch = t[i];
      if (ch === ' ' || D.g[ch]) { out += ch; continue; }
      var rep = D.hard[ch];
      if (rep == null) {
        var base = ch.normalize ? ch.normalize('NFD').replace(/[̀-ͯ]/g, '') : ch;
        rep = (base && base !== ch) ? base : null;
      }
      if (rep && rep.split('').every(function(c){ return c === ' ' || D.g[c]; })) out += rep;
      /* sonst: Zeichen fehlt in der Schrift -> weglassen (Generator meldet es) */
    }
    return out;
  }
  function adv(ch){ if (ch === ' ') return D.advs; var v = D.adv[ch]; return v != null ? +v : D.advd; }
  function kern(a, b){ var v = D.kern[a + ' ' + b]; return v ? +v : 0; }

  function gbox(n){
    var g = D.g[n]; if (!g) return null;
    if (g.b) return g.b;
    var x0 = 1e9, y0 = 1e9, x1 = -1e9, y1 = -1e9;
    g.r.forEach(function(r){ for (var i = 0; i < r.length; i += 2) { if (r[i] < x0) x0 = r[i]; if (r[i] > x1) x1 = r[i]; if (r[i+1] < y0) y0 = r[i+1]; if (r[i+1] > y1) y1 = r[i+1]; } });
    return (g.b = [x0, y0, x1, y1]);
  }
  function bandEdges(n, dx, band){
    var g = D.g[n], lo = 1e9, hi = -1e9;
    g.r.forEach(function(r){ for (var i = 0; i < r.length; i += 2) { var y = r[i+1]; if (y >= band[0] && y <= band[1]) { var x = r[i] + dx; if (x < lo) lo = x; if (x > hi) hi = x; } } });
    if (lo > hi) { var b = gbox(n); return [b[0] + dx, b[2] + dx]; }
    return [lo, hi];
  }
  function layout(names, gapFn, band){
    var placed = [], x = 0, lastR = null;
    for (var i = 0; i < names.length; i++) {
      var n = names[i];
      if (i) x += kern(names[i-1], n);
      if (n !== ' ' && D.g[n]) {
        var dx = x;
        var gap = (gapFn && i) ? gapFn(names[i-1], n) : null;
        if (gap != null && lastR != null) {
          var fehlt = (lastR + gap) - bandEdges(n, dx, band)[0];
          if (fehlt > 0) { x += fehlt; dx += fehlt; }
        }
        if (band) { var r = bandEdges(n, dx, band)[1]; lastR = lastR == null ? r : Math.max(lastR, r); }
        placed.push({ n: n, dx: dx });
      }
      x += adv(n);
    }
    return placed;
  }
  function bbox(placed){
    var x0 = 1e9, y0 = 1e9, x1 = -1e9, y1 = -1e9;
    placed.forEach(function(p){ var b = gbox(p.n); if (!b) return; x0 = Math.min(x0, b[0] + p.dx); x1 = Math.max(x1, b[2] + p.dx); y0 = Math.min(y0, b[1]); y1 = Math.max(y1, b[3]); });
    return [x0, y0, x1, y1];
  }
  function zielbreite(P, z){ return Math.max(20, Math.min(P.breite_basis_mm + (z - P.breite_basis_zeichen) * P.breite_je_zeichen_mm, P.max_design_width_mm)); }

  /* build_stitches(): liefert Glyphen + Masstab (Schrifteinheit -> mm) */
  function build(text, o){
    o = o || {};
    var P = {}; for (var k in D.prm) P[k] = D.prm[k];
    P.max_design_width_mm = o.maxW != null ? o.maxW : P.max_design_width_mm;
    if (o.k && o.k !== 1) ['name_height_mm', 'breite_basis_mm', 'breite_je_zeichen_mm', 'caps_max_breite_mm'].forEach(function(s){ P[s] *= o.k; });
    var names = substitute(text).split('');
    if (!names.filter(function(n){ return n !== ' '; }).length) return null;
    var probe = layout(names);
    var pb = bbox(probe);
    if (!(pb[3] > pb[1])) return null;
    var upm = (pb[3] - pb[1]) / P.name_height_mm;
    var capsU = P.caps_gap_mm * upm, lcU = P.lower_caps_gap_mm * upm, cl = P.caps_lower_overlap_mm;
    var gapFn = function(a, b){
      if (capsU && isUp(a) && isUp(b)) return capsU;
      if (lcU && isLow(a) && isUp(b)) return lcU;
      if (cl != null && isUp(a) && isLow(b)) return -cl * upm;
      return null;
    };
    var band = [pb[1] + 0.25 * (pb[3] - pb[1]), pb[1] + 0.75 * (pb[3] - pb[1])];
    var el = layout(names, gapFn, band);
    var ob = bbox(probe), eb = bbox(el);
    var capsZ = ((eb[2] - eb[0]) - (ob[2] - ob[0])) / upm;
    var factor = P.name_height_mm / (eb[3] - eb[1]);
    var breite = (eb[2] - eb[0]) * factor;
    var z = names.length;
    var ziel = Math.min(zielbreite(P, z) + Math.max(0, capsZ), P.max_design_width_mm);
    var deckel = P.caps_max_breite_mm || 0;
    var nurV = names.every(function(n){ return n === ' ' || isUp(n); });
    if (capsZ > 0 && deckel > 0) ziel = Math.min(ziel, Math.max(deckel, zielbreite(P, z)));
    var xf = 1;
    if (breite > ziel) {
      xf = Math.max(P.min_x_faktor, ziel / breite);
      if (capsZ > 0 && deckel > 0 && nurV && breite * xf > ziel) { factor *= ziel / (breite * xf); breite = ziel / xf; }
    }
    if (o.xFest > 0) xf = Math.min(1, o.xFest);
    if (breite * xf > P.max_design_width_mm) {
      xf = Math.max(P.min_x_faktor, P.max_design_width_mm / breite);
      if (breite * xf > P.max_design_width_mm) factor *= P.max_design_width_mm / (breite * xf);
    }
    var fx = factor * xf, fy = factor;
    return { g: el, fx: fx, fy: fy, box: [eb[0] * fx, eb[1] * fy, eb[2] * fx, eb[3] * fy] };
  }
  function bw(b){ return b ? b.box[2] - b.box[0] : 0; }

  /* pes_generator.generate(): Reihenfolge, Paar-Regel, compose_row */
  function compose(n1, n2, symKey, symAspect, pos){
    var P = D.prm, maxW = P.max_design_width_mm, gap = P.symbol_gap_mm;
    var sym = symKey ? { w: P.symbol_height_mm * (symAspect || 1), h: P.symbol_height_mm } : null;
    var budget = maxW - (sym ? sym.w + gap : 0);
    var p = (pos || '').toLowerCase();
    var folge = n2 ? ['n1', 'n2'] : ['n1'];
    if (sym) {
      if (p.indexOf('vor') === 0) folge = ['sym'].concat(folge);
      else if (p.indexOf('zwischen') === 0 && n2) folge = ['n1', 'sym', 'n2'];
      else folge = folge.concat(['sym']);
    }
    var getrennt = folge[1] === 'sym' && n2;
    var blocks = {};
    if (getrennt) {
      var rest = budget - gap, minx = P.min_x_faktor;
      var z1 = bw(build(n1, { maxW: maxW })), z2 = bw(build(n2, { maxW: maxW }));
      var natur = bw(build(n1, { maxW: 1e4, xFest: 1 })) + bw(build(n2, { maxW: 1e4, xFest: 1 }));
      var x = 1;
      if (z1 > 0 && z2 > 0 && natur > 0) x = Math.min(1, Math.max(minx, (z1 + z2) / natur));
      var k = 1, s1, s2;
      for (var it = 0; it < 5; it++) {
        s1 = build(n1, { maxW: 1e4, k: k, xFest: x });
        s2 = build(n2, { maxW: 1e4, k: k, xFest: x });
        var summe = bw(s1) + bw(s2);
        if (summe <= rest + 0.5) break;
        k *= rest / summe;
      }
      blocks.n1 = s1; blocks.n2 = s2;
    } else {
      blocks.n1 = build((n1 + ' ' + (n2 || '')).trim(), { maxW: budget });
      folge = folge.filter(function(f){ return f !== 'n2'; });
    }
    if (sym) blocks.sym = sym;
    var row = [], cursor = null;
    folge.forEach(function(key){
      var b = blocks[key]; if (!b) return;
      var x0, x1, cy;
      if (key === 'sym') { x0 = 0; x1 = b.w; cy = 0; }
      else { x0 = b.box[0]; x1 = b.box[2]; cy = (b.box[1] + b.box[3]) / 2; }
      var dx = cursor == null ? -x0 : cursor + gap - x0;
      row.push({ key: key, b: b, dx: dx, dy: key === 'sym' ? -b.h / 2 : -cy });
      cursor = x1 + dx;
    });
    var W = cursor || 0, s = W > maxW ? maxW / W : 1;
    var H = 0;
    row.forEach(function(r){ H = Math.max(H, r.key === 'sym' ? r.b.h : (r.b.box[3] - r.b.box[1])); });
    return { row: row, w: W * s, h: H * s, s: s };
  }

  /* Symbol-Bild auf den sichtbaren Inhalt zuschneiden (Alpha-Rahmen), einmal je Canvas */
  function crop(c){
    if (!c) return null;
    if (c.__mlrBB) return c.__mlrBB;
    var bb = { sx: 0, sy: 0, sw: c.width, sh: c.height };
    try {
      var d = c.getContext('2d').getImageData(0, 0, c.width, c.height).data, x0 = c.width, y0 = c.height, x1 = -1, y1 = -1;
      for (var y = 0; y < c.height; y += 2) for (var x = 0; x < c.width; x += 2) {
        if (d[(y * c.width + x) * 4 + 3] > 40) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
      }
      if (x1 > x0 && y1 > y0) bb = { sx: x0, sy: y0, sw: x1 - x0 + 1, sh: y1 - y0 + 1 };
    } catch (e) {}
    c.__mlrBB = bb;
    return bb;
  }

  /* Aufruf aus drawCanvasNow(): true = gezeichnet, false = alte Zeichnung verwenden */
  var last = null;
  function draw(ctx, s, o){
    if (!s || !s.font || s.font.key !== 'latein') { last = null; return false; }
    var n1 = (s.name || '').trim(), n2 = s.showName2 ? (s.name2 || '').trim() : '';
    if (RTL.test(n1 + n2)) return false;
    if (!D) { if (o.redraw) waiters.push(o.redraw); load(); return false; }
    var symKey = s.symbol && s.symbol.key && s.symbol.key !== 'kein' ? s.symbol.key : null;
    var color = (s.nameColor && s.nameColor.value) || '#1a1a1a';
    var symC = symKey && o.sym ? o.sym(symKey, color) : null;
    if (symKey && !symC) return false;   /* Symbolbild laedt noch -> alte Zeichnung haengt onload an */
    var bb = crop(symC);
    var aspect = bb ? bb.sw / bb.sh : 1;
    if (!n1 && !n2 && !symKey) return true;
    last = { s: s, o: o };
    var L = compose(n1, n2, symKey, aspect, s.symPosition || (n2 ? 'zwischen' : 'nach'));
    var cfg = o.cfg, W = o.W, H = o.H, fyP = cfg.FY != null ? cfg.FY : 1;
    var fs = Math.max(10, Math.round(W * cfg.FS));
    /* Masstab: 70 mm Namenshoehe = Hoehe der bisherigen Vorschau-Schrift (~0,72 em) */
    var pxMm = (fs * fyP * 0.72) / 70 * (cfg.STICK != null ? cfg.STICK : 1);
    window.__mlrTextBox = { cx: W * cfg.CX, cy: H * cfg.CY, w: L.w * pxMm / fyP, h: L.h * pxMm, rot: cfg.ROT };
    ctx.save();
    ctx.translate(W * cfg.CX, H * cfg.CY);
    if (cfg.ROT) ctx.rotate(cfg.ROT);
    ctx.scale(pxMm / fyP * L.s, pxMm * L.s);
    ctx.shadowColor = 'rgba(0,0,0,0.38)';
    ctx.shadowBlur = 2; ctx.shadowOffsetX = 0.6; ctx.shadowOffsetY = 0.8;
    ctx.fillStyle = color;
    L.row.forEach(function(r){
      if (r.key === 'sym') {
        if (symC && bb) ctx.drawImage(symC, bb.sx, bb.sy, bb.sw, bb.sh, r.dx, r.dy, r.b.w, r.b.h);
        return;
      }
      var b = r.b;
      ctx.beginPath();
      b.g.forEach(function(p){
        D.g[p.n].r.forEach(function(ring){
          for (var i = 0; i < ring.length; i += 2) {
            var X = (ring[i] + p.dx) * b.fx + r.dx, Y = ring[i+1] * b.fy + r.dy;
            if (i) ctx.lineTo(X, Y); else ctx.moveTo(X, Y);
          }
          ctx.closePath();
        });
      });
      ctx.fill('nonzero');
    });
    ctx.restore();
    return true;
  }

  /* Flache Stickvorschau: Name + Symbol gross und gerade auf Stoffgrund in Teppichfarbe,
     mit Satin-Schraffur. Fuer schwebende Vorschau und Set-Karte (das Teppichfoto zeigt den
     Namen nur ~20 px gross, Zoomen ins Foto bleibt unscharf). */
  var RUG = { schwarz: '#232222', hellgrau: '#b8b6b3', grau: '#b8b6b3', blau: '#1e2a55', gruen: '#24442f',
              rot: '#7a1b21', lila: '#4f2a6e', rosa: '#c4848d', beige: '#d6c3a6', weiss: '#ece8e1' };
  var noise = null;
  function noisePattern(ctx){
    if (!noise) {
      noise = document.createElement('canvas'); noise.width = noise.height = 96;
      var c = noise.getContext('2d'), im = c.createImageData(96, 96);
      for (var i = 0; i < im.data.length; i += 4) { var v = Math.random() * 255; im.data[i] = im.data[i+1] = im.data[i+2] = v; im.data[i+3] = 16; }
      c.putImageData(im, 0, 0);
    }
    return ctx.createPattern(noise, 'repeat');
  }
  function shade(hex, f){
    var n = parseInt(hex.replace('#', ''), 16), r = n >> 16, g = (n >> 8) & 255, b = n & 255;
    var t = f < 0 ? 0 : 255, a = Math.abs(f);
    r = Math.round((t - r) * a + r); g = Math.round((t - g) * a + g); b = Math.round((t - b) * a + b);
    return 'rgb(' + r + ',' + g + ',' + b + ')';
  }
  function paintFlat(canvas, cssW, cssH, dpr){
    if (!last || !D) return false;
    var s = last.s, o = last.o;
    var n1 = (s.name || '').trim(), n2 = s.showName2 ? (s.name2 || '').trim() : '';
    if (!n1 && !n2) return false;
    var symKey = s.symbol && s.symbol.key && s.symbol.key !== 'kein' ? s.symbol.key : null;
    var color = (s.nameColor && s.nameColor.value) || '#d4a574';
    var symC = symKey && o.sym ? o.sym(symKey, color) : null, bb = crop(symC);
    var L = compose(n1, n2, symC ? symKey : null, bb ? bb.sw / bb.sh : 1, s.symPosition || (n2 ? 'zwischen' : 'nach'));
    canvas.width = Math.round(cssW * dpr); canvas.height = Math.round(cssH * dpr);
    var c = canvas.getContext('2d');
    c.setTransform(dpr, 0, 0, dpr, 0, 0);
    var K = window.mlrKern, key = (K && (K._colorKey || K.colorKey)) || 'rosa';
    var bg = RUG[key] || RUG.rosa;
    var gr = c.createRadialGradient(cssW * 0.45, cssH * 0.4, 0, cssW * 0.5, cssH * 0.5, Math.max(cssW, cssH) * 0.75);
    gr.addColorStop(0, shade(bg, 0.10)); gr.addColorStop(1, shade(bg, -0.22));
    c.fillStyle = gr; c.fillRect(0, 0, cssW, cssH);
    c.fillStyle = noisePattern(c); c.fillRect(0, 0, cssW, cssH);
    /* Masstab: Motiv fuellt 84 % der Breite bzw. 62 % der Hoehe */
    var k = Math.min(cssW * 0.84 / L.w, cssH * 0.62 / L.h);
    var ox = (cssW - L.w * k) / 2, oy = cssH / 2;
    c.save();
    c.translate(ox, oy); c.scale(k * L.s, k * L.s);
    var mm = 1 / (k * L.s);   /* 1 css px in mm */
    L.row.forEach(function(r){
      if (r.key === 'sym') {
        if (symC && bb) {
          c.save(); c.shadowColor = 'rgba(0,0,0,0.35)'; c.shadowBlur = 3; c.shadowOffsetY = 1.2;
          c.drawImage(symC, bb.sx, bb.sy, bb.sw, bb.sh, r.dx, r.dy, r.b.w, r.b.h); c.restore();
        }
        return;
      }
      var b = r.b;
      c.beginPath();
      b.g.forEach(function(p){
        D.g[p.n].r.forEach(function(ring){
          for (var i = 0; i < ring.length; i += 2) {
            var X = (ring[i] + p.dx) * b.fx + r.dx, Y = ring[i+1] * b.fy + r.dy;
            if (i) c.lineTo(X, Y); else c.moveTo(X, Y);
          }
          c.closePath();
        });
      });
      /* Garn: leichter Verlauf, Schatten fuer Erhabenheit, Satin-Schraffur */
      var y0 = b.box[1] + r.dy, y1 = b.box[3] + r.dy;
      var lg = c.createLinearGradient(0, y0, 0, y1);
      lg.addColorStop(0, shade(color, 0.22)); lg.addColorStop(0.5, color); lg.addColorStop(1, shade(color, -0.18));
      c.save();
      c.shadowColor = 'rgba(0,0,0,0.38)'; c.shadowBlur = 3; c.shadowOffsetX = 0.6; c.shadowOffsetY = 1.4;
      c.fillStyle = lg; c.fill('nonzero');
      c.restore();
      c.save(); c.clip('nonzero');
      c.strokeStyle = shade(color, -0.35); c.globalAlpha = 0.22; c.lineWidth = 0.35 * mm * 2;
      var x0 = b.box[0] + r.dx - 80, x1 = b.box[2] + r.dx + 80, step = 1.1 * mm * 2;
      c.beginPath();
      for (var x = x0; x < x1; x += step) { c.moveTo(x, y0 - 5); c.lineTo(x + (y1 - y0 + 10) * 0.55, y1 + 5); }
      c.stroke();
      c.restore();
    });
    c.restore();
    return true;
  }

  window.mlrStick = {
    draw: draw,
    crop: crop,
    paintFlat: paintFlat,
    /* Vorschau in eigener Aufloesung neu zeichnen (Set-Karte, schwebende Vorschau): canvas
       bekommt Breite W*mult; Geometrie wie der Haupt-Canvas. false = nichts gezeichnet. */
    paintInto: function(canvas, mult){
      if (!last || !D) return false;
      var o = last.o, W = o.W, H = o.H;
      mult = Math.max(1, Math.min(mult || 1, 12));
      canvas.width = Math.round(W * mult); canvas.height = Math.round(H * mult);
      var c = canvas.getContext('2d');
      c.setTransform(mult, 0, 0, mult, 0, 0);
      c.clearRect(0, 0, W, H);
      var box = window.__mlrTextBox, ok = draw(c, last.s, o);
      window.__mlrTextBox = box;
      return ok;
    },
    ready: function(){ return !!D; },
    onReady: function(fn){ if (D) fn(); else { waiters.push(fn); load(); } },
    /* zum Pruefen in der Konsole: mlrStick.layout('Aisha','', 'herz') -> Masse in mm wie in der PES */
    layout: function(n1, n2, sym, aspect){ if (!D) return null; var L = compose(n1 || '', n2 || '', sym || null, aspect || 1, n2 ? 'zwischen' : 'nach');
      return { breite_mm: Math.round(L.w * 10) / 10, hoehe_mm: Math.round(L.h * 10) / 10, teile: L.row.map(function(r){ return r.key + ':' + (r.key === 'sym' ? Math.round(r.b.w) + 'x' + Math.round(r.b.h) : Math.round(r.b.box[2] - r.b.box[0]) + 'x' + Math.round(r.b.box[3] - r.b.box[1])); }) }; }
  };
})();
